<template>
  <div class="home" id="home">
    <div class="banner-wrap">
      <div class="banner">
        <div class="banner-content">
          <div class="ban-numwrap">
            <div class="ban-item">
              <img src="@/assets/num-order.png" alt />
              <div class="num">
                <!-- <IOdometer :value="9927251880" /> -->
                <IOdometer :value="Number(orderVal)" />
                <p class="txt">新增销售订单（单）</p>
              </div>
            </div>
            <div class="ban-item">
              <img src="@/assets/num-sale.png" alt />
              <div class="num">
                <!-- <IOdometer :value="992540731555" /> -->
                <IOdometer :value="Number(saleVal)" />
                <p class="txt">新增销售额（元）</p>
              </div>
            </div>
            <div class="ban-item">
              <img src="@/assets/num-pack.png" alt />
              <div class="num">
                <!-- <IOdometer :value="994093249" /> -->
                <IOdometer :value="Number(packVal)" />
                <p class="txt">发出包裹（个）</p>
              </div>
            </div>
            <div class="ban-item">
              <img src="@/assets/num-city.png" alt />
              <div class="num" style="font-size:32px;font-weight:500">
                {{dataList[0]}}/{{dataList[1]}}/{{dataList[2]}}
                <p class="txt" style="margin-top:48px">销售热点城市</p>
              </div>
            </div>
          </div>
          <div class="more-wrap">
            <span class="pd-right">{{dataDateStr}}吉客云一周数据，由于数据过于真实，不接受质疑！</span>
            <span @click="goStatistics" style="cursor: pointer">点击查看更多数据>></span>
          </div>
        </div>
      </div>
      <div class="msg-wrap">
        <div class="msg-con">
          <div class="info-icon">
            <img style="margin-bottom: 2px;" src="../assets/info.png" alt />
          </div>
          <div class="textBox" style="cursor: pointer">
            <transition name="slide">
              <p class="text" :key="text.id" @click="toNotice">{{text.val}}</p>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="install-wrap">
      <div class="install-con">
        <div class="install-toptxt">
          <span class="redcolor">1分钟</span>下载安装
          <span class="redcolor" style="margin-left:40px">即刻</span>免费试用
        </div>
        <div class="install-items">
          <div id="wrap">
            <div class="item" @click="centerDialogVisible=true">
              <div class="item-imgs-wrap">
                <img src="../assets/bg-win.png" alt="windows下载" class="img-unhover" />
                <img src="../assets/download.png" alt="点击下载" class="img-hover" />
              </div>
              <div class="item-txt-wrap">
                <p class="txt-title">Windows版</p>
                <p class="txt-unhover">下载量：{{pcNum}}</p>
                <p class="txt-hover">请点击下载</p>
              </div>
            </div>
            <div
              class="item"
              @click="download('https://jkyun-static.oss-cn-hangzhou.aliyuncs.com/client-update/mac/jackyun-mac.dmg?OSSAccessKeyId=LTAIh08vjrfC7HV0&Expires=5163507203&Signature=%2FgJHsV8f59fUh5MFWL9hDETyECM%3D','close',2)"
            >
              <div class="item-imgs-wrap">
                <img src="../assets/apple.png" alt="MAC版下载" class="img-unhover" />
                <img src="../assets/download.png" alt="点击下载" class="img-hover" />
              </div>
              <div class="item-txt-wrap">
                <p class="txt-title">MAC版</p>
                <p class="txt-unhover">下载量：{{macNum}}</p>
                <p class="txt-hover">请点击下载</p>
              </div>
            </div>
            <div
              class="item"
              @click="download('//jkyun-client.oss-cn-hangzhou.aliyuncs.com/prod/mobile/normal/jackyun-apk/jackyun.apk?OSSAccessKeyId=LTAIh08vjrfC7HV0&Expires=11613630739&Signature=bKySdX%2Fq%2F6flW6BMnRNuhIU7pcU%3D','close',3)"
            >
              <div class="item-imgs-wrap">
                <img src="../assets/android.png" alt="安卓下载" class="img-unhover" />
                <img src="../assets/androidDownload.png" alt="扫描二维码下载" class="code-img-hover" />
              </div>
              <div class="item-txt-wrap">
                <p class="txt-title">安卓版</p>
                <p class="txt-unhover">下载量：{{androidNum}}</p>
                <p class="txt-hover">扫描二维码下载</p>
              </div>
            </div>
            <div
              class="item"
              @click="download('https://apps.apple.com/cn/app/%E5%90%89%E5%AE%A2%E4%BA%91/id1482887633','open',0)"
            >
              <div class="item-imgs-wrap">
                <img src="../assets/ios.png" alt="iOS版下载" class="img-unhover" />
                <img src="../assets/IOSCode.png" alt="扫描二维码下载" class="code-img-hover" />
              </div>
              <div class="item-txt-wrap">
                <p class="txt-title">IOS版</p>
                <p class="txt-unhover">&nbsp;</p>
                <p class="txt-hover">扫描二维码下载</p>
              </div>
            </div>
            <div class="item">
              <div class="item-imgs-wrap">
                <img src="../assets/small.png" alt="小程序" class="img-unhover" />
                <img src="../assets/jackyunApplets.png" alt="扫描二维码使用" class="code-img-hover" />
              </div>
              <div class="item-txt-wrap">
                <p class="txt-title">小程序版</p>
                <p class="txt-unhover">&nbsp;</p>
                <p class="txt-hover">扫描二维码使用</p>
              </div>
            </div>
          </div>
        </div>
        <div class="face-wraps" style="cursor: pointer">
          <div class="face" style="background-color:rgb(251,252,255)" @click="goVideo(videoSrc3)">
            <div class="face-imgs face1"></div>
            <p class="face-txt">怎么免费试用，还要等人工审核？我性子急，被其他公司套路怕了...</p>
          </div>
          <div class="face" @click="goVideo(videoSrc2)">
            <div class="face-imgs face2"></div>
            <p class="face-txt">有些浏览器打开就可以用，你们为什么还要下载客户端？</p>
          </div>
          <div class="face" style="background-color:rgb(251,252,255)" @click="maskName = 'coupon'">
            <div class="face-imgs face3"></div>
            <p class="face-txt">虚假宣传！下载不止用了1分钟！</p>
          </div>
          <div class="face" @click="go(webUrl)">
            <div class="face-imgs face4"></div>
            <p class="face-txt">我懒，不高兴下载，只想简单看看</p>
          </div>
        </div>
      </div>
    </div>
    <div class="video-box">
      <div class="video-bg">
        <div class="video-wrap">
          <div class="title white">
            <span class="redcolor">8分钟</span>短视频，快速了解吉客云
          </div>
          <div class="videobox" style="cursor: pointer">
            <video-player
              class="video-player-box"
              ref="videoPlayer"
              :options="playerOptions"
              :playsinline="true"
              customEventName="customstatechangedeventname"
            ></video-player>
          </div>
        </div>
      </div>
    </div>
    <div class="wraps" style="width:100%;margin:0 auto">
      <div class="face-wrapsbot" style="cursor: pointer">
        <div class="face" @click="goVideoPage">
          <div class="face-imgs face5"></div>
          <p class="face-txt">不够看，还有更多吗......</p>
        </div>
        <div class="face" style="background-color:rgb(251,252,255)" @click="goScene()">
          <div class="face-imgs face2"></div>
          <p class="face-txt">
            都是你们自说自话，有纯天然无
            <br />加工的用户现场视频吗？
          </p>
        </div>
        <div class="face" @click="goWebsite">
          <div class="face-imgs face1"></div>
          <p class="face-txt">
            功能太强大了，但是很多功能
            <br />我们现在还用不上....
          </p>
        </div>
      </div>
    </div>
    <div class="background-white">
      <div class="company-all">
        <div class="title">
          刚刚，第
          <span class="redcolor">{{companyCount}}</span>家企业加入了吉客云
        </div>
        <div class="companys-wrap">
          <div class="companys-wrap2">
            <div class="companys">
              <span class="com-item" v-for="(item,index) in typicalImgs" :key="index">
                <img :src="item.logoUrl" alt />
              </span>
            </div>
          </div>
        </div>
        <div class="wraps" style="width:100%;margin:0 auto">
          <div class="face1-wrap">
            <div class="face1" @click="goCustom" style="cursor: pointer">
              <div class="face1-img face-icon1"></div>
              <div class="face1-txt">都是大牌，有我们村吗？</div>
            </div>
            <!-- <div class="face1" style="background-color:rgb(251,252,255)">
              <div class="face1-img face-icon2"></div>
              <div class="face1-txt">
                有更详细的案例库吗？
                <br />我想了解他们具体怎么用的。
              </div>
            </div>-->
            <div class="face1-temp" style="background-color:rgb(251,252,255)">
              <div class="face1-img-temp face-icon2-temp"></div>
              <div class="face1-txt-temp">
                有更详细的案例库吗？
                <br />我想了解他们具体怎么用的。
              </div>
            </div>
            <div class="face1" @click="maskName = 'noDisplay'" style="cursor: pointer">
              <div class="face1-img face-icon3"></div>
              <div class="face1-txt">
                我要低调，
                <br />不希望出现在这个名单里面···
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="price-wrap">
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="price-box">
        <div class="title white">价格公开透明，拒绝套路！</div>
        <div class="swiper-container">
          <div class="swiper-wrapper" style="cursor: pointer">
            <div class="swiper-slide" name="tab1" url="/sell/jikeyun">
              <div class="price-title">账号授权费用</div>
              <div class="prices">
                <div class="price-name gray">3账号套餐</div>
                <div class="price-item">1140元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">5账号套餐</div>
                <div class="price-item">1900元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">10账号套餐</div>
                <div class="price-item">3600元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">20账号套餐</div>
                <div class="price-item">6600元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">50账号套餐</div>
                <div class="price-item">15000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">100账号套餐</div>
                <div class="price-item">28000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">150账号套餐</div>
                <div class="price-item">39000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">200账号套餐</div>
                <div class="price-item">49000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">250账号套餐</div>
                <div class="price-item">56250元/年</div>
              </div>
              <div class="price-bar">
                <div class="price-detail">查询详情</div>
                <div class="price-icon">
                  <img src="@/assets/jiantou.png" alt />
                </div>
              </div>
            </div>
            <div class="swiper-slide" name="tab2" url="/sell/jikeyun">
              <div class="price-title">销售订单流量费</div>
              <div class="prices">
                <div class="price-name gray">1万单套餐</div>
                <div class="price-item">1000元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">3万单套餐</div>
                <div class="price-item">2700元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">9万单套餐</div>
                <div class="price-item">7200元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">20万单套餐</div>
                <div class="price-item">14000元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">50万单套餐</div>
                <div class="price-item">30000元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">100万单套餐</div>
                <div class="price-item">50000元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">200万单套餐</div>
                <div class="price-item">80000元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">400万单套餐</div>
                <div class="price-item">120000元</div>
              </div>
              <div class="price-bar">
                <div class="price-detail">查询详情</div>
                <div class="price-icon">
                  <img src="@/assets/jiantou.png" alt />
                </div>
              </div>
            </div>
            <div class="swiper-slide" name="tab4" url="/sell/jikeyun">
              <div class="price-title">包年套餐</div>
              <div class="prices">
                <div class="price-name gray">3万套餐</div>
                <div class="price-item">30000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">5万套餐</div>
                <div class="price-item">50000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">8万套餐</div>
                <div class="price-item">80000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">16万套餐</div>
                <div class="price-item">160000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">39万套餐</div>
                <div class="price-item">390000元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">89万套餐</div>
                <div class="price-item">890000元/年</div>
              </div>
              <div class="price-bar">
                <div class="price-detail">查询详情</div>
                <div class="price-icon">
                  <img src="@/assets/jiantou.png" alt />
                </div>
              </div>
            </div>
            <div class="swiper-slide" name="tab3" url="/sell/jikeyun">
              <div class="price-title">增值模块订购费</div>
              <div class="prices">
                <div class="price-name gray">wms增强</div>
                <div class="price-item">1900元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">wmsAPI</div>
                <div class="price-item">1200元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">财务总账</div>
                <div class="price-item">1900元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">支付对账</div>
                <div class="price-item">1900元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">
                  支付对账
                  <p class="itemwhite">充单量</p>
                </div>
                <div class="price-item">1000元/30万单</div>
              </div>
              <div class="prices">
                <div class="price-name gray">
                  生产MRP
                  <p class="itemwhite">基础版</p>
                </div>
                <div class="price-item">3999元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">
                  生产MRP
                  <p class="itemwhite">标准版</p>
                </div>
                <div class="price-item">8999元/年</div>
              </div>
              <div class="prices">
                <div class="price-name gray">
                  文件存储
                  <p class="itemwhite">100G</p>
                </div>
                <div class="price-item">280元/年</div>
              </div>
              <div class="price-bar">
                <div class="price-detail">查询详情</div>
                <div class="price-icon">
                  <img src="@/assets/jiantou.png" alt />
                </div>
              </div>
            </div>
            <!-- <div class="swiper-slide" name="tab4" url="/sell/hardsoft">
              <div class="price-title">手机短信</div>
              <div class="prices">
                <div class="price-name gray">1千条套餐</div>
                <div class="price-item">100元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">1万条套餐</div>
                <div class="price-item">700元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">3万条套餐</div>
                <div class="price-item">1800元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">5万条套餐</div>
                <div class="price-item">2750元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">8万条套餐</div>
                <div class="price-item">4000元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">12万条套餐</div>
                <div class="price-item">5400元</div>
              </div>
              <div class="prices">
                <div class="price-name gray">24万条套餐</div>
                <div class="price-item">10320元</div>
              </div>
              <div class="price-bar">
                <div class="price-detail">查询详情</div>
                <div class="price-icon">
                  <img src="@/assets/jiantou.png" alt />
                </div>
              </div>
            </div>-->
            <div class="swiper-slide" name="tab5" url="/sell/hardsoft">
              <div class="price-title">硬件</div>
              <div class="prices">
                <div class="price-name gray">PDA(一维)</div>
                <div class="price-item">2980元/台</div>
              </div>
              <div class="prices">
                <div class="price-name gray">PDA(二维)</div>
                <div class="price-item">3380元/台</div>
              </div>
              <!-- <div class="prices">
                <div class="price-name gray">电子秤(自动称重)</div>
                <div class="price-item">830元/台</div>
              </div>-->
              <div class="prices">
                <div class="price-name gray">蓝牙电子秤</div>
                <div class="price-item">900元/台</div>
              </div>
              <div class="prices">
                <div class="price-name gray">静态称重录单工作台</div>
                <div class="price-item">11980元/台</div>
              </div>
              <div class="prices">
                <div class="price-name gray">自动称重录单工作台</div>
                <div class="price-item">19800元/台</div>
              </div>
              <div class="prices">
                <div class="price-name gray">一维无线激光扫描枪</div>
                <div class="price-item">310元/台</div>
              </div>
              <div class="price-bar">
                <div class="price-detail">查询详情</div>
                <div class="price-icon">
                  <img src="@/assets/jiantou.png" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="face3-wrap" style="cursor: pointer">
          <div class="face1" @click="goCalculator">
            <div class="face1-img face3-icon8"></div>
            <div class="face1-txt white">一头雾水，我究竟要花多少钱？</div>
          </div>
          <div class="face1" @click="goVideo(videoSrc6)" style="margin-right:80px">
            <div class="face1-img face3-icon2"></div>
            <div class="face1-txt white">你们是如何做到比其他的系统价格更便宜的？</div>
          </div>
          <div class="face1" @click="goVideo(videoSrc7)">
            <div class="face1-img face7"></div>
            <div class="face1-txt white">为什么不把多年费用打包销售？</div>
          </div>
        </div>
      </div>
    </div>
    <div class="background-white">
      <div class="contact-we">
        <div class="title pd-bot20">联系我们，嫌麻烦请点击右侧在线QQ</div>
        <p class="sub-title">客服服务时间 9:00 - 22:30 (节假日 9:00 - 18:00)</p>
        <div class="contact-wrap">
          <div class="contact-item item1">
            <div class="contact-text">
              <p class="contact-txt">
                <span>软件购买：</span>
              </p>
              <p class="contact-txt">吉客云客户端登录>>订购续费>>在线订购</p>
              <p class="contact-txt">电话：0571-88223317</p>
            </div>
          </div>
          <div class="contact-item item2">
            <div class="contact-text">
              <p class="contact-txt">
                <span>售后服务：</span>
              </p>
              <p class="contact-txt">服务通道：客户端登录>>客户经理</p>
              <p class="contact-txt">电话：0571-88223317</p>
            </div>
          </div>
          <div class="contact-item item5">
            <div class="contact-text">
              <p class="contact-txt">
                <span>老客户续购：</span>
              </p>
              <p class="contact-txt">联系您的客户经理</p>
              <p class="contact-txt">或自助续购：吉客云登录>>订购续费>>在线订购</p>
              <p class="contact-txt">电话：0571-88223317</p>
            </div>
          </div>
          <div class="contact-item item3">
            <div class="contact-text">
              <p class="contact-txt">
                <span>代理加盟：</span>
              </p>
              <table class="contact-table">
                <tr>
                  <td style="padding-right:2px">马先生</td>
                  <td style="text-align: right;">电话：</td>
                  <td>13805740671</td>
                </tr>
                <tr>
                  <td></td>
                  <td style="text-align: right;">QQ：</td>
                  <td>2461490329</td>
                </tr>
              </table>
              <table class="contact-table">
                <!-- <tr>
                  <td style="padding-right:2px">史先生</td>
                  <td style="text-align: right;">电话：</td>
                  <td>19905817260</td>
                </tr> -->
                <tr>
                  <td></td>
                  <td style="text-align: right;">QQ：</td>
                  <td>671767902</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="contact-item item4">
            <div class="contact-text">
              <p class="contact-txt">
                <span>平台对接：</span>
              </p>
              <p class="contact-txt">QQ：1753651123</p>
              <p class="contact-txt">EMAIL：cj@differsoft.com</p>
            </div>
          </div>

          <div class="contact-item item6">
            <div class="contact-text">
              <p class="contact-txt">
                <span>媒体合作：</span>
              </p>
              <table class="contact-table">
                <tr>
                  <td style="padding-right:2px">韩女士</td>
                  <td style="text-align: right;">电话：</td>
                  <td>18627982201</td>
                </tr>
                <tr>
                  <td></td>
                  <td style="text-align: right;">企业微信：</td>
                  <td>18627982201</td>
                </tr>
              </table>
              <p class="contact-txt">
                吉客云示范仓入仓申请
                <a
                  style="color:rgb(14,101,242);cursor: pointer"
                  @click="go('http://bbs.es86.com/aspx/topic.aspx?tid=17049')"
                >链接：>></a>
              </p>
            </div>
          </div>
        </div>
        <div class="face2-wrap">
          <div class="face1" @click="maskName = 'complaint'" style="cursor: pointer">
            <div class="face1-img face1-icon7"></div>
            <div class="face1-txt">联系不上，很生气，后果很严重</div>
          </div>
        </div>
      </div>
    </div>
    <div class="friend-wraps">
      <div class="friend-wrap">
        <div class="title white">我们的朋友，我们相互成就，共同进步</div>
        <div class="friend-items">
          <div class="friend-img" v-for="(item,index) in dealImgs" :key="index">
            <img :src="item.logoUrl" alt />
          </div>
        </div>
        <div class="face2-wrap">
          <div
            class="face1 face-icon7"
            @click="maskName = 'cooperationRegister'"
            style="cursor: pointer"
          >
            <div class="face1-img face7"></div>
            <div class="face1-txt white">我也想跟你们合作</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      top="220px"
      title="Windows版下载"
      :visible.sync="centerDialogVisible"
      width="600px"
      center
      class="pcBox"
    >
      <div class="pc-wrap">
        <div class="pc-item">
          <div class="pc-img7">
            <img src="../assets/win7up.png" alt />
          </div>
          <div class="pc-txt">Windows7及以上版本</div>
          <el-button
            type="primary"
            @click="download('https://jkyun-static.oss-cn-hangzhou.aliyuncs.com/client-update/win7up/jackyunSetup.exe?OSSAccessKeyId=LTAIh08vjrfC7HV0&Expires=5163957586&Signature=MiZKSdVwhuPBcUBkRVc2Nw2EQsQ%3D','close',1)"
          >下载</el-button>
        </div>
        <div class="pc-item">
          <div class="pc-imgxp">
            <img src="../assets/winxp.png" alt />
          </div>
          <div class="pc-txt">Windows XP版本</div>
          <el-button
            type="primary"
            @click="download('https://jkyun-static.oss-cn-hangzhou.aliyuncs.com/client-update/winxp/jackyunSetup_xp.exe?OSSAccessKeyId=LTAIh08vjrfC7HV0&Expires=5163955475&Signature=q4BQM0qAUIWwzUI7SpvtUfdGV0M%3D','close',1)"
          >下载</el-button>
        </div>
      </div>
    </el-dialog>
    <page-mask v-if="maskName !== ''" @close="maskName = ''" :componentName="maskName"></page-mask>
  </div>
</template>

<script>
import Swiper from "swiper";
import { videoPlayer } from "vue-video-player";
import videoPlay from "@/components/video-play";
import {
  getCaseTypicalUserList,
  getDealCompany,
  getCountUsers,
  getDownloadNum,
  setDownloadNum,
  getIndexData,
  listDynamic,
  getFreeExperience
} from "@/api/index";
import IOdometer from "vue-odometer";
import "odometer/themes/odometer-theme-default.css";
import pageMask from "@/components/page-mask.vue";
var vm = this;
export default {
  name: "Home",
  components: {
    videoPlayer,
    videoPlay,
    IOdometer,
    pageMask
  },
  data() {
    return {
      allData: {},
      webUrl: "",
      dataList: ["上海", "北京", "广州"], //首页banner数据
      allCity: "",
      sourceType: 0,
      pcNum: 0,
      iosNum: 0,
      macNum: 0,
      androidNum: 0,
      centerDialogVisible: false, //PC下载
      companyCount: 0,
      //数字滚动设置的值
      packVal: 0, // 包裹量
      saleVal: 0, // 销售额
      // delay: 200,
      orderVal: 0, // 订单量
      // options: {
      //   startVal: 0,
      //   useEasing: true,
      //   useGrouping: true,
      //   separator: ",",
      //   decimal: ".",
      //   prefix: "",
      //   suffix: ""
      // },
      dealImgs: [],
      typicalImgs: [],
      // videoSrc1: "",
      videoSrc2:
        "//jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786336601866880/668064320953713152.mp4?Expires=4716439489&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=iQDHGA43WsWYHPa1UbnmXDpbYa0%3D",
      videoSrc3:
        "//jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786336601866880/899202096180167424.mp4?Expires=4743993253&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=VyXrMVwFxigkCaviMVYQ9Etz8No%3D",
      // videoSrc4: "",
      videoSrc5:
        "//jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786377966092928/784549849459261952.mp4?Expires=4730325762&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=JnKqZRG%2FPZ1KdmVWqrCu0xtBYJA%3D",
      videoSrc6:
        "//jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786336601866880/667940558807237248.mp4?Expires=4716424746&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=yN%2B3lZlWun8Yoxoz8DcGW3rmpdc%3D",
      videoSrc7:
        "http://jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786268721250944/936708586865001216.mp4?Expires=4748464428&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=EJVwYnHa5Eq5VPo1Gp8i%2B5h1ZCg%3D",
      videoShow: false,
      videoSrc:
        "//cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm",
      playerOptions: {
        muted: false, // 默认情况下将会消除任何音频。
        language: "en",
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        sources: [
          {
            type: "video/mp4",
            src:
              "//jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/53/jkpan/533786268721250944/924448597155447936.mp4?Expires=4747002999&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=1eaUm8hLcrgTw7w9pZFXCgyK4qA%3D"
          }
        ],
        poster:
          "https://jkyun.oss-cn-hangzhou.aliyuncs.com/longterm/414893596397930496/system/cms/925381881110562048.png?Expires=4747114116&OSSAccessKeyId=LTAIh08vjrfC7HV0&Signature=ZSXiu6zRoSUeOMdsXE2uEKByfs8%3D", //视频的封面地址
        fluid: true, //比例缩放以适应其容器
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //  controlBar: {
        //    timeDivider: true,
        //    durationDisplay: true,
        //    remainingTimeDisplay: false,
        //    fullscreenToggle: true  //全屏按钮
        //  }
      },
      textArr: [],
      number: 0,
      screenWidth: document.body.clientWidth,
      goUrl: ["/sell/jikeyun"],
      goTab: ["tab2"],
      timer: "",
      swiper: {},
      maskName: "", // 要打开的窗口的名字，为空则关闭
      dataDateStr: "" // 数据的处理后的日期字符串
    };
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.textArr[this.number]
      };
    },
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  mounted() {
    window.addEventListener("resize", this.isSwiper); //注册监听器
    this.isSwiper();
    this.startMove();
    // 每6小时自动刷新数据
    this.timer = setInterval(() => {
      this.getIndex();
    }, 5000);
  },

  methods: {
    //判断swiper的个数
    isSwiper() {
      //获取分辨率使用不同swiper数量
      if (document.body.clientWidth <= 1440) {
        this.initSwiper(3);
      } else {
        this.initSwiper(4);
      }
    },
    //跳转到sell页的指定位置
    goSell: function(page, selectedId) {
      localStorage.setItem("toId", selectedId);
      // window.location.href = "/static/pages/sell.html";
      window.open("/pages/sell.html", "_blank");
      // window.location.href = "/pages/sell.html";
      // let sellRouters = this.$router.resolve({ path: page });
      // window.open(sellRouters.href, "_blank");
    },
    //更多数据
    goStatistics() {
      let customRoutes = this.$router.resolve({ path: "/statistics" });
      window.open(customRoutes.href, "_blank");
    },
    //典型客户
    goCustom() {
      let customRoutes = this.$router.resolve({ path: "/custom" });
      window.open(customRoutes.href, "_blank");
    },
    //查看更多视频
    goVideoPage() {
      let videoRoutes = this.$router.resolve({ path: "/videos" });
      window.open(videoRoutes.href, "_blank");
    },
    //现场实拍
    goScene() {
      this.$store.commit("changeNotice", 6);
      this.$router.replace("/notice");
      window.scrollTo(0, 0);
    },
    //去外链
    goWebsite() {
      window.open("http://www.wdgj.com");
    },
    //查看计算器
    goCalculator() {
      let calculatorRoutes = this.$router.resolve({ name: "calculator" });
      window.open(calculatorRoutes.href, "_blank");
    },
    //获取首页数据
    getIndex() {
      getIndexData().then(res => {
        this.allData = res.result.data;
        if (this.allData.hotCities.length > 0) {
          this.dataList = this.allData.hotCities;
        }
        this.orderVal = Number(this.allData.orderQuantity);
        this.saleVal = Number(this.allData.sales);
        this.packVal = Number(this.allData.parcelQuantity);
        // let arr = this.allData.statisticsDate.split("-");
        // this.dataDateStr =
        //   "吉客云" + (arr[1] - 0) + "月" + (arr[2] - 0) + "日数据，";
      });
    },
    //累加客户端下载量
    setDownload(type) {
      let params = {
        ip: this.ip,
        sourceType: type
      };
      setDownloadNum(params).then(res => {
        switch (type) {
          case 1:
            this.pcNum = this.pcNum + 1;
            break;
          case 2:
            this.macNum = this.macNum + 1;
            break;
          case 3:
            this.androidNum = this.androidNum + 1;
            break;
          case 4:
            this.iosNum = this.iosNum + 1;
            break;
        }
      });
    },
    //获取客户端下载量
    getDownload() {
      getDownloadNum().then(res => {
        let data = res.result.data;
        data.forEach(item => {
          switch (item.sourceType) {
            case 1:
              this.pcNum = item.downloadNum;
              break;
            case 2:
              this.macNum = item.downloadNum;
              break;
            case 3:
              this.androidNum = item.downloadNum;
              break;
            case 4:
              this.iosNum = item.downloadNum;
              break;
          }
        });
      });
    },
    download(src, flag, type) {
      if (flag === "open") {
        window.open(src);
      } else {
        window.location.href = src;
      }
      this.setDownload(type);
    },
    //获取公司数量
    getAllUsers() {
      getCountUsers().then(res => {
        this.companyCount = res.result.data;
      });
    },
    //销售订单跳动
    onReady: function(instance, CountUp) {
      const that = this;
      instance.update(that.orderVal);
    },
    //销售额的
    onReady1: function(instance, CountUp) {
      const that = this;
      instance.update(that.saleVal);
    },
    onReady2: function(instance, CountUp) {
      const that = this;
      instance.update(that.packVal);
    },
    go(url) {
      window.open(url);
    },
    goVideo(src) {
      this.$emit("func", src);
    },
    //关闭视频弹窗
    closevideo() {
      this.videoShow = false;
    },

    initSwiper(num) {
      new Swiper(".swiper-container", {
        slidesPerView: num,
        spaceBetween: 10,
        // centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 2,
        observer: true,
        observeParents: true,
        // slidesPerView: 'auto',//可以自定义slide的宽度
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        onClick: function(e) {
          vm.goSell(
            e.clickedSlide.getAttribute("url"),
            e.clickedSlide.getAttribute("name")
          );
        }
      });
    },

    //消息无缝滚动
    startMove() {
      setTimeout(() => {
        if (this.number === 2) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 2000); // 滚动不需要停顿则将2000改成动画持续时间
    },
    //获取典型用户列表
    getTypicalUserList() {
      getCaseTypicalUserList().then(res => {
        let data = res.result.data;
        this.typicalImgs = [...data, ...data]; //复制一份数据在后面
      });
    },
    getCompany() {
      getDealCompany().then(res => {
        this.dealImgs = res.result.data;
      });
    },
    //点击公告跳转
    toNotice() {
      this.$store.commit("changeNotice", 1);
      this.$router.replace("/notice");
    },
    //获取动态列表
    getlistDynamic() {
      let params = {
        params: {
          groupId: 1
        }
      };
      listDynamic(params).then(res => {
        if (res.result.data.length == 0) {
          this.textArr = [];
        } else {
          let noticeArr = res.result.data.map(
            ({ dynamicTitle }) => dynamicTitle
          );
          this.textArr = noticeArr.slice(0, 3);
        }
      });
    }
  },
  created() {
    vm = this;
    //获取企业
    this.getTypicalUserList();
    //获取我们的朋友企业
    this.getCompany();
    this.getAllUsers();
    //获取PC下载量
    this.getDownload();
    this.ip = returnCitySN["cip"];
    this.getIndex();
    this.getlistDynamic();
    getFreeExperience().then(res => {
      this.webUrl = res.result.data;
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {
    window.removeEventListener("resize", this.isSwiper);
  }
};
</script>
<style  lang="less" scoped>
// @deep: ~'>>>';
.background-white {
  width: 100%;
  background-color: #f6f6f6;
}
.pcBox {
  /deep/.el-dialog__header {
    width: 600px;
    background: #fff;
    /deep/.el-dialog__title {
      line-height: 60px;
    }
  }
}
.pc-wrap {
  width: 600px;
  height: 180px;
  background: #fff;
  display: flex;
  .pc-item {
    flex: 1;
    border-right: 1px solid rgb(212, 210, 210); /*no */
    text-align: center;
    button {
      padding: 10px 25px;
      background-color: #5485e8;
    }
    .pc-img7 {
      width: 58px;
      height: 58px;
      margin: 0 auto;
    }
    .pc-imgxp {
      width: 68px;
      height: 61px;
      margin: -3px auto 0;
    }
    &:last-child {
      border-right: 0;
    }
    .pc-txt {
      padding: 12px;
      text-align: center;
    }
  }
}
.mar-top {
  margin-top: 82px !important;
}
.pd-top {
  padding-top: 20px;
  margin-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.font-34 {
  font-size: 34px;
}
.info-icon {
  width: 27px;
  // height:24px;
  transform: scale(0.8);
}

.videobox {
  width: 1540px;
  height: 674px;
  margin: 0 auto;
  // 调整播放器样式
  /deep/ .vjs-big-play-button {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  /deep/.video-js .vjs-control-bar {
    padding-right: 20px !important;
  }
  /deep/.video-js.vjs-fluid,
  .video-js.vjs-16-9,
  .video-js.vjs-4-3 {
    height: 100% !important;
  }
}

.price-title {
  background-color: rgb(211, 227, 252);
  color: #333333;
  font-size: 20px;
  padding: 25px 0;
  text-align: center;
}
.prices {
  display: flex;
  justify-content: space-between;
  .price-item {
    padding: 20px 30px 0;
    font-size: 16px;
    color: #333;
  }
  .price-name {
    padding: 20px 10px 0 30px;
    font-size: 16px;
    color: #333;
  }
  .gray {
    color: #666666;
  }
}

.swiper-container {
  width: 100%;
  height: 100%;
  margin-bottom: 60px;
}
.swiper-slide {
  width: 320px;
  text-align: center;
  font-size: 18px;
  background: #fff;
  height: 535px;
  margin-right: 0px;
  position: relative;
  transition: 300ms;
  transform: scale(0.95);
  .swiper-slide-active {
    width: 50px;
    margin-right: 10px;
  }
  .price-bar {
    border-top: 0.5px solid rgb(211, 227, 252); /*no */
    width: 85%;
    position: absolute;
    bottom: 0;
    margin: 0 20px;
    .price-detail {
      float: left;
      color: #666666;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      margin-top: 15px;
      margin-left: 15px;
    }
    .price-icon {
      float: right;
      width: 40px;
      height: auto;
      margin-top: 10px;
    }
  }
}
.swiper-slide:hover {
  transform: scale(1);
  .price-detail {
    color: rgb(14, 101, 242);
  }
}

.cardBanner {
  position: relative;
  margin-bottom: 60px;
}
.cardBanner ul {
  display: flex;
  overflow: scroll; /*设置滚动条*/
}
.cardBanner ul::-webkit-scrollbar {
  /*隐藏滚动条*/
  display: none;
}
.cardBanner ul > li {
  width: 320px;
  height: 535px;
  background-color: #fff;
  flex-shrink: 0;
  padding-left: 3%;
  text-align: center;
  margin-right: 50px;
  display: inline-block;
}
.cardBanner ul > li:first-child {
  padding-left: 0;
}
.cardBanner ul > li a {
  display: block;
  width: 100%;
  height: 100%;
}
.cardBanner ul > li img {
  width: 100%;
  height: 170px;
  border-radius: 5px;
}
.cardBanner ul > li p {
  margin: 0;
}
[class^="arrow"] {
  font-size: 30px;
  transform: scaleX(0.7);
  color: #ddd;
}
.arrow-left {
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
}
.arrow-right {
  position: absolute;
  right: 5px;
  top: 50%;
  margin-top: -17px;
}

.price-wrap {
  width: 100%;
  // min-width: 1580px;
  background: #0e65f2 url("../assets/bg.png") repeat-y;
  background-size: 100%;
  position: relative;
  z-index: 1;
  /deep/ .swiper-button-prev {
    width: 60px;
    height: 67px;
    margin-left: 50px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAaVBMVEUAAAB3pvN2p/N1qv93pvN2pvN2pvJ2p/N2p/J3p/N2p/N2p/N3p/N2p/R3p/N3p/R0p/R1qfV0pfd5qvOArv+ApP93p/J3p/N3pfR1p/R2pvJ3p/N2pvN3p/J1pvJ3p/V3p/Z1qvR3p/OAPFKdAAAAInRSTlMA1voQ6afx4ce5rp6ahGtCLiUdFQsH239dWPTOvo5kSzoYAKspSgAAALdJREFUSMft1ckSgjAQhGECyCL7Liou/f4P6dxy/qvMjb5/BZV0ZqIzYXPogk0laYLmKtEvzU8zFTPJw0zDzNeZaZkZcjM3ZvpUit/MfDLp3jHTxVLWM7ObSQdmWknryExjxiXM1GaKmdetXBBZSl7RpDBTMzM5MxszY27mFbE4M3sEs/peh/09fxABj5xfLq8RLyx/GvwR8ufOBwsfYXxYhh/LfgGEXzV+qfEiBl7UPlt6RGf+lx97yRTbyJ29LAAAAABJRU5ErkJggg==") !important;
    background-size: 100% !important;
    outline: none;
    &:hover {
      background-size: 100% !important;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABHNCSVQICAgIfAhkiAAAAtVJREFUaEPt2T9oE1EcB/DvL4k1d0EcxKLY9AIqCrmkuDg4mUFx0KEuSlFQxC52ESdFUbvo5CIu2kWpVB0EUUG6JAjukqtFqZI/SDuIRbS5a2t7P4ntXa5YSMn9q49kvRzv97nf+/N77xEE+5FgHrRB6z2j7Qy1M7TGL1As63eIcBHA04win1zja//8bV10Oa1cGwLROSu6eIfUuXs7fWsFFTpIK+vPQei1gmfGSDYl97WCqb8TGmhykuXv88YrEHI2BvwwqyTOtIoJDfRlmjfXfup5ItpnBU/AbVWRL7vBhAL6UOJtJhl5EPbaGOYBNZW45xYTOEirzu4Em3kAyeXgTQKdVRXpkReYQEHj1Tl1kRcKAG2pN8yM34RIbyYVf+0VJjCQVtYPAHgDwqa/GKBGETqaSUoFLzGBgLTK7CGw+RKEjUuZ4R/R2IZcuqvjvdcY30FaVT/BjGECYkvB85QZi+Z6dsQ/+YHxFTRWrl1goruOte6zGUWup0v+6hfGN1CxWhskpmuOBVOLRuSD6SRN+4nxBVSs1O4T6Lwj8HcRSTqS7qQZvzGegpg5OlYxnoFwvBE4j0a65WNpovkgMJ6BSiWOz0T0FwAdtgNnPFEV6RQRLQaF8QRUr8v0X8YogP2OMfMgqyT6g4RYbbmqtiemeOvsnPHWWZcBdCOjSDfDwLjK0PikoSzMc4EIqeXgmZj61ZQ0FBbGFahY1j8SYY+dakKf2i2PhIlxBdIq+gSAXQ0Anc4o0vB/CxKuy9UzsdqkQOBBVUlcDytTrma5etBCTdtWFoRaWO3FVKTSxzlehClOV6BE2j5YMKE2eBZKqC24jRLpkMRGiXSMZaGEOmhsjCmBjoItlFCH9RZqtesUgG9llMQVt0Wt6+K01QCEuvByfgRhriRXogS6NG6USsZVhjlAoMdqSr7UalcObQy1GnCz99qgZl8o7OftDIWdgWbtC5ehP2w5UESGpdKsAAAAAElFTkSuQmCC") !important;
    }
  }
  /deep/ .swiper-button-next {
    width: 60px;
    height: 67px;
    margin-right: 50px;
    background-size: 100% !important;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABHNCSVQICAgIfAhkiAAAAthJREFUaEPt2T9o1HAUB/Dvu7uCrUlxcRAEdXISdXETWgoiaBH/hV6siqBd6qbmKigeFdFLLQg6+YcWtU17hYrgpJQOgoOLog5uVlxEJ+8X2wppnvzSuzbzXZK7+3HZMiS8T96PX957P4JiFynmQQvU6BltZUjpDFmOmCHgBDOP2mbn5UbAVr3kLk0sbcukvIUKgkFP7Kx2vt6oqkEy8NykmAbBWEdh1s7qx+uJqgkkA7ec0jiBzq6hGPMdunY430uL9YDVDAoyNVUqgMkKAT4grXUXDPqTNCoSUIByxCCAB2sAxlc/Q90jhvYzSVRkoAA14Z4B8RgIKXnPwI8VP7N/9FT796RQkYJWM/X3ELP/gghtAYrxy0+h526f/iUJVOQgGfSQI7p85ldEtHEVxYIoc7CQ7XgXNyoWkAz6yoS7h8ifJ6JN5eX3D0y9tqm9iRMVGyjY0oulneTRPAhbygjPB/pHsvp0XKhYQQHq+eJWSntvAdpezhQz88CI2fk4DlTsIBn01aLY7HuYA2FXaFsfLpj6jahRiYBk0Pkia4uemCOifSHEo0JWH4gSlRgoQI3xhqUN7ksAByoIBma/pTVjxqCVKGCJgmTAJ4uc3rHiFgk4FgK8bl/WjuTP0XKtqMRBlYBzjngI4MJappjfd2T0nrxBbi2ouoFWqwpxE8C10EbxOZVBz21D/10tqq6gMmqQgfuEygSKFzy/rava+q/uoOBf5binCfx0ffnhk23qu6vJUkOAcpNuP4ifhUAfbVPf25Qg2Ucps+QsRwwTcF2JTUGZbVupH6tSpY9SxalS7YNSDZ5SLbhSQxKlxlhDTumozzStxKBRjoI5xeOVVqCpR8GWU8oR6E6oLmveYb3lCNmgXQyV+016nMJM1pQYU+bAK+eIohzkhEdSTXskqeqh8T0AfbLjtE39VjUtc9TPNMRMIUpUCxTl14zjXa0MxfFVo3ynchn6D4plXUT9dN0iAAAAAElFTkSuQmCC") !important;
    outline: none;
    &:hover {
      background-size: 100% !important;
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABHNCSVQICAgIfAhkiAAAAttJREFUaEPt2U9o03AUB/Dvy/64JENEUdiQNUVE2Br/XLwJGwMRVMR/w8PUi+6iR9GLIkwEPQhCPfmHDT1twkTwpIweBA9e1LSK4GFNN/8wT+Ka1K3tk2TplnObpO2P5tZDw/vkJb/3fu9HEOwiwTxogRo9o60MCZ0hw7SeE3AKjHu6plxpBGzVr9yXH3astMLZNQTzE11TL9QbVTXICTxtWlMARtZRmNE15WQ9UTWBnMANMz9JoPM+VGpLp3ykt5esesBqBq2irLsEXK0AmPmDulEZ2rGZ/kSNCgTkBJ3J5i8x0QNfpr5KLA8NxOlXlKjAQC7KtM8xeAKA5CHm2zroQH+vbEaFChTkLhTZwmFG+QUROpzfzLzYLrUP9/dtyESBChzkoubtQS7zKwJUF8H4C+CQrinvwkaFAnKC/rywvLdUXEkR0SYP9Q8kHdVjXW/CRIUGcoL+9L2wSyqWUgD1rCYKRSKM6n2KU79CuUIFuagFazsV8ZYImidgYhpLaPLjMEShg5ygv/3krfayNUsgvYIg8Hgipt4MGhUJyP2mFrm7bNuzAPavFWDwo90xdSxIVGQgJ+i5Oe5akqyXAB30FeCZREweIaJSELBIQV5dasuY9jQIJ9YB/Lq7rByLx6lQKypyUCVgw8w/JNBFH+C9JMvDA9toqRZU3UBO0EYuf4uYrvu+qbTcqQzv7KHf1aLqCnKC9praJLA6gWJGtr2TBqvt/+oOchBp0z4L8NP1hYINXVP3VJOlRgGNAvzMB/qoa+q+pgQJ9coZufw4Md0QYlEQZtlmZnEKq1Ctj1DNqVDbB6E2eEJtwYUakgg1xkrPW8e5hCkhBo3eKHiyshUA0LyjYMO0rhFwxzcraN5hvZGzksS4vNZkNutxCjNTOmdNCHPgZZjWNAGn/SOppj2SFPXQ+D6YzwBSUtfk29VsmYP+T0PMFIJEtUBBPs0w7tXKUBhPNch7Cpeh/2NHYEQeqaEHAAAAAElFTkSuQmCC") !important;
      color: rgba(255, 255, 255, 1) !important;
    }
  }
}
.friend-wraps {
  background-color: #1445ae;
}
.friend-wrap {
  width: 1440px;
  margin: 0 auto;

  .friend-items {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .friend-img {
      width: 191px;
      height: 191px;
      background-color: #fff;
      margin: 0 45px 45px 0;
    }
    .friend-img:nth-child(6n) {
      margin-right: 0px;
    }
  }
}
.contact-txt {
  text-align: left;
  padding: 12px 0 0 15px;
  font-size: 16px;
  span {
    font-weight: 600;
  }
}
.contact-table {
  font-size: 16px;
  width: 253px;
  margin: 12px 0 0 15px;
  text-align: left; /*文本居中*/
  border-collapse: collapse; /*表格的边框合并，如果相邻，则共用一个边框*/
  border-spacing: 0; /*设置行与单元格边框的间距。当表格边框独立（即border-collapse:separate;）此属性才起作用*/
  td {
    line-height: 16px;
    height: 26px;
  }
}

.sub-title {
  color: #fa2a54;
  font-size: 18px;
  margin-bottom: 45px;
}
.contact-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-bottom: 30px;
  .contact-text {
    float: left;
    margin-top: 20px;
    margin-left: 15px;
  }
  .contact-item {
    margin: 0 0 20px 0;
    background-color: #fff;
    width: 460px;
    height: 189px;
  }
  .item1 {
    background: url(../assets/softpurcase.png) no-repeat 350px 90px;
    background-color: #fff;
    background-size: 90px;
  }
  .item2 {
    background: url(../assets/servece.png) no-repeat 350px 90px;
    background-color: #fff;
    background-size: 90px;
  }
  .item3 {
    background: url(../assets/agent.png) no-repeat 350px 90px;
    background-color: #fff;
    background-size: 90px;
  }
  .item4 {
    background: url(../assets/coperation.png) no-repeat 350px 90px;
    background-color: #fff;
    background-size: 90px;
  }
  .item5 {
    background: url(../assets/renew.png) no-repeat 350px 90px;
    background-color: #fff;
    background-size: 90px;
  }
  .item6 {
    background: url(../assets/interview.png) no-repeat 350px 90px;
    background-color: #fff;
    background-size: 90px;
  }
}
.video-wrap {
  width: 100%;
  height: 842px;
  margin: 0 auto;
  overflow: hidden;
  background: url(../assets/videoBar.jpg) no-repeat 0 0;
  background-size: 100% 100%;
  .title {
    font-weight: Bold;
  }
}
.company-all,
.contact-we,
.price-box {
  width: 1440px;
  margin: 0 auto;
  overflow-x: hidden;
}

.face1-wrap {
  display: flex;
  margin: 0 auto;
  overflow: hidden;
  margin-right: 5px;
  justify-content: space-between;

  .face1 {
    width: 400px;
    height: 125px;
    background-color: #fff;
    padding: 30px 100px;
    &:hover {
      box-shadow: 0px 3px 32px rgba(0, 0, 0, 0.16);
      transform: scale(1.02);
      .face1-txt {
        color: #5485e8;
      }
      .face-icon1 {
        background: url("../assets/icon55.png") no-repeat;
        background-size: 100% 100%;
      }
      .face-icon2 {
        background: url("../assets/icon22.png") no-repeat;
        background-size: 100% 100%;
      }
      .face-icon3 {
        background: url("../assets/icon11.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .face1-imgs {
      width: 50px;
      height: 50px;
      margin: 0 auto 25px;
    }
    .face-icon1 {
      background: url("../assets/icon5.png");
      background-size: 100% 100%;
    }
    .face-icon2 {
      background: url("../assets/icon2.png") no-repeat;
      background-size: 100% 100%;
    }
    .face-icon3 {
      background: url("../assets/icon1.png") no-repeat;
      background-size: 100% 100%;
    }
    .face1-txt {
      color: #3e3e3e;
      font-size: 14px;
      text-align: left;
    }
  }

  .face1-temp {
    width: 400px;
    height: 85px;
    background-color: #fff;
    padding: 68px 100px 30px 100px;
    display: flex;

    .face1-img-temp {
      width: 50px;
      height: 50px;
      margin: 0 auto 25px;
    }
    .face-icon2-temp {
      background: url("../assets/icon2.png") no-repeat;
      background-size: 100% 100%;
    }

    .face1-txt-temp {
      color: #3e3e3e;
      font-size: 14px;
      text-align: left;
    }
  }
}

.face3-wrap {
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  .face1 {
    width: 440px;
    height: 100px;
    &:hover {
      .face1-txt {
        font-size: 18px;
        text-align: center;
      }
      .face3-icon8 {
        background: url("../assets/icon88.png");
        background-size: 100% 100%;
      }
      .face3-icon2 {
        background: url("../assets/icon22.png");
        background-size: 100% 100%;
      }
      .face7 {
        background: url("../assets/icon-yukuai1.png");
        background-size: 100% 100%;
      }
    }
  }
  .face1-imgs {
    width: 50px;
    height: 50px;
    margin: 0 auto 25px;
  }
  .face3-icon8 {
    background: url("../assets/icon8.png");
    background-size: 100% 100%;
  }
  .face3-icon2 {
    background: url("../assets/icon2.png");
    background-size: 100% 100%;
  }
  .face7 {
    width: 44px !important;
    height: 44px !important;
    background: url("../assets/icon-yukuai.png");
    background-size: 100% 100%;
  }
}
.face2-wrap {
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  .face-icon7 {
    &:hover {
      .face1-txt {
        font-size: 18px;
      }
      .face7 {
        width: 44px;
        height: 44px;
        background: url("../assets/icon-yukuai1.png");
        background-size: 100% 100%;
      }
    }
    .face7 {
      width: 44px;
      height: 44px;
      background: url("../assets/icon-yukuai.png");
      background-size: 100% 100%;
    }
  }
  .face1 {
    &:hover {
      .face1-txt {
        font-size: 18px;
      }
      .face1-icon7 {
        background: url("../assets/icon77.png");
        background-size: 100% 100%;
      }
    }
  }
  .face1-icon7 {
    background: url("../assets/icon7.png");
    background-size: 100% 100%;
  }
}
.face1 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  &:hover {
    .face-icon1 {
      background: url("../assets/icon22.png");
      background-size: 100% 100%;
    }
    .face-icon2 {
      background: url("../assets/icon55.png");
      background-size: 100% 100%;
    }
    .face-icon3 {
      background: url("../assets/icon66.png");
      background-size: 100% 100%;
    }
  }
  .face1-img {
    width: 50px;
    height: 50px;
    margin: 20px 10px 20px 20px;
  }
  .face-icon1 {
    background: url("../assets/icon2.png");
    background-size: 100% 100%;
  }
  .face-icon2 {
    background: url("../assets/icon5.png");
    background-size: 100% 100%;
  }
  .face-icon3 {
    background: url("../assets/icon6.png");
    background-size: 100% 100%;
  }
  .face1-txt {
    font-size: 16px;
  }
}
.companys-wrap {
  height: 420px;
  overflow: hidden;
  margin-bottom: 8px;
}
.companys-wrap2 {
  height: 840px;
}
.companys:hover {
  animation-play-state: paused;
}
.companys {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  position: relative;
  animation: rolling 18s infinite linear;
  @keyframes rolling {
    0% {
      top: 0%;
    }
    100% {
      top: -100%;
    }
  }
  .com-item {
    display: block;
    width: 203px;
    height: 140px;
    background-color: #fff;
    margin: 1px;
    img {
      display: block;
    }
  }
}
.title {
  padding: 58px 0;
  font-size: 40px;
}
.pd-bot20 {
  padding-bottom: 20px;
}
.white {
  color: #fff;
}
.black {
  color: #333;
}
.face-wraps {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  .face {
    width: 372px;
    background-color: #fff;
    padding: 30px 50px;
    // margin-right:20px;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      box-shadow: 0px 3px 32px rgba(0, 0, 0, 0.16);
      transform: scale(1.02);
      .face1 {
        background: url("../assets/icon11.png");
        background-size: 100% 100%;
      }
      .face2 {
        background: url("../assets/icon22.png");
        background-size: 100% 100%;
      }
      .face3 {
        background: url("../assets/icon33.png");
        background-size: 100% 100%;
      }
      .face4 {
        background: url("../assets/icon44.png");
        background-size: 100% 100%;
      }
      .face-txt {
        color: #5485e8;
      }
    }
    .face-imgs {
      width: 50px;
      height: 50px;
      margin: 0 auto 25px;
    }
    .face1 {
      background: url("../assets/icon1.png");
      background-size: 100% 100%;
    }
    .face2 {
      background: url("../assets/icon2.png");
      background-size: 100% 100%;
    }
    .face3 {
      background: url("../assets/icon3.png");
      background-size: 100% 100%;
    }
    .face4 {
      background: url("../assets/icon4.png");
      background-size: 100% 100%;
    }
    .face-txt {
      color: #3e3e3e;
      font-size: 14px;
      text-align: left;
    }
  }
}
.face-wrapsbot {
  width: 100%;
  // max-width: 1920px;
  margin: 0 auto;
  display: flex;
  overflow-x: hidden;
  background-color: #fff;
  overflow: hidden;
  justify-content: center;

  .face {
    width: 372px;
    padding: 30px 50px;
    &:hover {
      box-shadow: 0px 3px 32px rgba(0, 0, 0, 0.16);
      transform: scale(1.02);
      .face-txt {
        color: #5485e8;
        text-align: center;
      }
      .face5 {
        background: url("../assets/icon55.png") no-repeat;
        background-size: 100% 100%;
      }
      .face2 {
        background: url("../assets/icon22.png") no-repeat;
        background-size: 100% 100%;
      }
      .face1 {
        background: url("../assets/icon11.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .face-imgs {
      width: 50px;
      height: 50px;
      margin: 0 auto 25px;
    }
    .face5 {
      background: url("../assets/icon5.png");
      background-size: 100% 100%;
    }
    .face2 {
      background: url("../assets/icon2.png") no-repeat;
      background-size: 100% 100%;
    }
    .face1 {
      background: url("../assets/icon1.png") no-repeat;
      background-size: 100% 100%;
    }
    .face-txt {
      color: #3e3e3e;
      font-size: 14px;
      text-align: left;
      text-align: center;
    }
  }
}
.video-box {
  width: 100%;
}
.video-bg {
  background-color: #ffffff;
  // max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  // height: 1028px;
  video,
  .video-player-box {
    width: 100%;
    height: 100%;
    // height: 840px !important;
  }
}

.redcolor {
  color: #5485e8;
}
.install-wrap {
  padding: 66px 0;
  background-color: #fff;
  .install-con {
    width: 1440px;
    margin: 0 auto;
    .install-toptxt {
      font-size: 48px;
      margin: 0 0 20px;
      font-weight: Bold;
    }
    .install-items {
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px;
      a {
        text-decoration: none;
      }
      #wrap {
        display: flex;
        justify-content: space-around;
        align-items: center;
        align-content: center;
        width: 100%;
        height: 300px;
      }
      .item {
        display: inline-block;
        position: relative;
        width: auto;
        height: 200px;
        overflow: hidden;
        cursor: pointer;
      }
      .item-imgs-wrap {
        position: relative;
        width: 120px;
        height: 120px;
      }
      .item-txt-wrap {
        position: relative;
        top: 10px;
        width: 120px;
        text-align: center;
        -webkit-transition: all 0.4s;
        -o-transition: all 0.4s;
        transition: all 0.4s;
      }
      .img-unhover,
      .img-hover,
      .code-img-hover {
        top: 0;
        left: 0;
        width: 120px;
        height: 120px;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
      .img-unhover {
        position: relative;
        opacity: 1;
      }
      .img-hover {
        position: absolute;
        opacity: 0;
        -webkit-transform: scale(0.7);
        -ms-transform: scale(0.7);
        transform: scale(0.7);
      }
      .code-img-hover {
        position: absolute;
        opacity: 0;
      }
      .item:hover .img-unhover {
        opacity: 0;
        -webkit-transform: scale(0.4);
        -ms-transform: scale(0.4);
        transform: scale(0.4);
      }
      .item:hover .img-hover {
        opacity: 1;
        -webkit-transform: scale(0.5);
        -ms-transform: scale(0.5);
        transform: scale(0.5);
      }
      .item:hover .code-img-hover {
        opacity: 1;
        -webkit-transform: scale(0.9);
        -ms-transform: scale(0.9);
        transform: scale(0.9);
      }

      .txt-title {
        margin: 10px auto;
        font-size: 18px;
        color: #333;
      }
      .txt-unhover,
      .txt-hover {
        position: relative;
        margin: 10px auto;
        font-size: 14px;
        color: #9e9eb6;
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        transition: all 0.3s;
      }
      .txt-unhover {
        left: 0;
        opacity: 1;
      }
      .txt-hover {
        top: -29px;
        opacity: 0;
      }
      .item:hover .item-txt-wrap {
        top: -10px;
      }
      .item:hover .txt-unhover {
        opacity: 0;
      }
      .item:hover .txt-hover {
        opacity: 1;
      }
    }
  }
}

.banner-wrap {
  padding-top: 120px;
  width: 100%;
  height: 430px;
  background-image: url("../assets/banner.png");
  background-size: 100% 100%;
  position: relative;
  .banner {
    display: inline-block;
    text-align: center;
    .banner-content {
      width: 1440px;
      position: relative;
      color: #fff;
      .ban-date {
        font-size: 30px;
        margin-top: 10px;
        opacity: 0.6;
      }
      .ban-numwrap {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 95px;
        .ban-item {
          display: flex;
          justify-content: space-between;
          img {
            width: 25px;
            height: 28px;
            margin-right: 4px;
          }
          .num {
            font-size: 38px;
            font-weight: 600;
            line-height: 32px;
            color: rgba(174, 187, 213, 1);
            text-align: left;
            .txt {
              font-size: 16px;
              line-height: 36px;
              color: rgba(212, 214, 228, 0.6);
              margin-top: 30px;
            }
          }
        }
      }
      .more-wrap {
        width: 1320px;
        margin-top: 110px;
        font-size: 14px;
        text-align: right;
        .pd-right {
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }
  .msg-wrap {
    height: 56px;
    background: rgba(50, 53, 57, 0.5);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    .msg-con {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      height: 60px;
      align-items: center;
    }
  }
}
/deep/.odometer.odometer-auto-theme .odometer-digit .odometer-digit-inner,
/deep/.odometer.odometer-theme-default .odometer-digit .odometer-digit-inner {
  top: -10px;
}

/deep/.odometer-formatting-mark {
  line-height: 30px;
  vertical-align: top;
}

.textBox {
  width: 100%;
  height: 35px;
  margin: 0 0 15px 15px;
  overflow: hidden;
  position: relative;
  font-size: 14px;
}

.text {
  position: absolute;
  bottom: 0;
  color: #fff;
  left: 0;
  height: 30px;
  line-height: 35px;
}
/**banner消息轮播的动画 */
.slide-enter-active,
.slide-leave-active {
  transition: all 1.5s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
.itemwhite {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  float: right;
  color: rgb(168, 168, 168);
  margin-left: 5px;
  padding-top: 4px;
}
img {
  width: 100%;
  height: 100%;
}
@media (max-width: 1440px) {
  .ban-numwrap {
    width: 100%;
  }
  .more-wrap {
    position: absolute;
    width: 1260px;
    right: 50px;
  }
  .banner-wrap {
    .msg-wrap {
      width: 100%;
      .msg-con {
        width: 100%;
      }
    }
  }

  .banner-wrap {
    .banner {
      .banner-content {
        width: 1260px;
      }
    }
    .msg-wrap {
      .msg-con {
        width: 100%;
      }
    }
  }

  .info-icon {
    margin-left: 50px;
  }

  .install-wrap {
    .install-con {
      width: 1260px;
      .install-items {
        height: 300px;
        margin: 0 30px;
      }
    }
  }
  .company-all {
    width: 1260px;
    .companys {
      padding: 0 30px;
      .com-item {
        width: 198px;
        height: 130px;
      }
    }
  }
  .contact-we,
  .price-box,
  .friend-wrap {
    width: 1260px;
  }
  .price-wrap {
    width: 100%;
    min-width: 1260px;
    /deep/ .swiper-button-prev {
      margin-left: 0;
    }
    /deep/ .swiper-button-next {
      margin-right: 0;
    }
  }

  .face-wraps {
    margin: 0 33px;
    .face {
      width: 297px;
      padding: 30px 40px;
    }
  }

  .face1-wrap {
    margin: 0 30px;
    .face1 {
      padding: 20px 70px;
    }
    .face1-temp {
      height: 100%;
      padding: 60px 100px 30px 100px;
    }
  }

  .contact-wrap {
    padding: 0 30px;
    .contact-item {
      position: relative;
      margin: 0 0 15px 0;
      width: 387px;
      height: 200px;
    }
    .item1 {
      background: url(../assets/softpurcase.png) no-repeat 278px 90px;
      background-color: #fff;
      background-size: 90px;
    }
    .item2 {
      background: url(../assets/servece.png) no-repeat 278px 90px;
      background-color: #fff;
      background-size: 90px;
    }
    .item3 {
      background: url(../assets/agent.png) no-repeat 278px 90px;
      background-color: #fff;
      background-size: 90px;
    }
    .item4 {
      background: url(../assets/coperation.png) no-repeat 278px 90px;
      background-color: #fff;
      background-size: 90px;
    }
    .item5 {
      background: url(../assets/renew.png) no-repeat 278px 90px;
      background-color: #fff;
      background-size: 90px;
    }
    .item6 {
      background: url(../assets/interview.png) no-repeat 278px 90px;
      background-color: #fff;
      background-size: 90px;
    }
  }

  .friend-wrap {
    width: 1260px;
    .friend-items {
      margin: 0 30px;
      .friend-img {
        width: 180px;
        height: 180px;
        margin: 0 24px 24px 0;
      }
      .friend-img:nth-child(6n) {
        margin-right: 0px;
      }
    }
  }
  .swiper-container {
    width: 90%;
  }
}

.el-dialog__wrapper {
  /deep/.el-dialog {
    // width: 100%;
    // margin-top: 0 !important;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0);
    border-radius: 0px;
    -webkit-box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
    box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
  }
  /deep/.el-dialog__header {
    padding: 0px 0px 0px;
  }
  /deep/.el-dialog__body {
    display: inline-block;
    padding: 0px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue